import { useOrderContext } from "app/providers/OrderProvider";
import StatusGif from "entities/status-gif";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { isTestEnvironment } from "shared/utils/checkEnvironment";
import { twMerge } from "tailwind-merge";
import StatusSupport from "widgets/status-support";

const ZakelijkBankTransferStatus = () => {
  const { order } = useOrderContext();

  if (!order) return null;
  const shipmentDate = new Date(order.shipmentDate).toLocaleDateString(
    "nl-NL",
    {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    },
  );
  return (
    <>
      <div
        className={twMerge(
          isTestEnvironment() ? "gg-mx-auto" : "",
          "gg-max-w-3xl",
        )}
      >
        <div className="gg-mb-14">
          <StatusGif
            src={`https://media1.giphy.com/media/ua4OxpbgAtItnS5hWu/giphy.gif`}
            alt="Een GewoonGers Gif. Een monteur springt uit zijn bus."
          />

          <Heading
            headingLevel="h1"
            className="gg-mb-3 md:gg-mb-5 md:gg-text-6xl"
          >
            Bedankt voor je bestelling!
          </Heading>

          <div className="gg-space-y-3">
            <Text className="gg-mb-3 gg-text-xl gg-font-semibold md:gg-mb-5 md:gg-text-2xl">
              Binnenkort kun je ons verwachten op het opgegeven bezorgadres.
            </Text>

            <Text className="gg-text-lg">
              De bestelling wordt gereed gemaakt voor verzending en bezorgd op{" "}
              <span className="gg-whitespace-nowrap gg-font-bold">
                {shipmentDate}
              </span>{" "}
              op het bij ons bekende bezorgadres.
            </Text>

            <Text className="gg-text-lg">
              Twee dagen voor levering ontvang je van ons rond de klok van{" "}
              <span className="gg-font-bold">18.00</span> uur (ook in het
              weekend) een bericht met tijdsindicatie waarin je de chauffeur
              kunt verwachten.
            </Text>

            <Text className="gg-text-lg">
              Je hebt gekozen voor betaling op factuur. De factuur zal per
              e-mail worden verstuurd. We zien de betaling na levering graag
              binnen 14 dagen tegemoet.
            </Text>
          </div>
        </div>

        <StatusSupport />
      </div>
    </>
  );
};
export default ZakelijkBankTransferStatus;
